<div class="w-full md:w-[512px]">
  <input [value]="value" (keydown.enter)="onEnter()"
         (input)="onInputChange($event)"
         class="w-full border border-gray-400  rounded-lg  p-2  text-gray-800 placeholder-gray-400 focus:outline-none"
         [placeholder]="placeholder"
  />
</div>
